module.exports = __webpack_public_path__ + "SR.png?3929da968578bdc82866467524b14be5";